var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61035 0.556641C4.80098 0.556641 0.0478516 3.76289 0.0478516 8.95195C0.0478516 12.252 1.9041 14.127 3.0291 14.127C3.49316 14.127 3.76035 12.8332 3.76035 12.4676C3.76035 12.0316 2.64941 11.1035 2.64941 9.28945C2.64941 5.5207 5.51816 2.84883 9.23066 2.84883C12.4229 2.84883 14.7854 4.66289 14.7854 7.9957C14.7854 10.4848 13.7869 15.1535 10.5525 15.1535C9.38535 15.1535 8.38691 14.3098 8.38691 13.1004C8.38691 11.3285 9.62441 9.61289 9.62441 7.78477C9.62441 4.68164 5.22285 5.24414 5.22285 8.99414C5.22285 9.78164 5.32129 10.6535 5.67285 11.3707C5.02598 14.1551 3.7041 18.3035 3.7041 21.1723C3.7041 22.0582 3.83066 22.9301 3.91504 23.816C4.07441 23.9941 3.99473 23.9754 4.23848 23.8863C6.60098 20.652 6.5166 20.0191 7.58535 15.7863C8.16191 16.8832 9.65254 17.4738 10.8338 17.4738C15.8119 17.4738 18.0479 12.6223 18.0479 8.24883C18.0479 3.59414 14.026 0.556641 9.61035 0.556641Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.e8803f4e.svg";
export { ForwardRef as ReactComponent };